import React, { useCallback, useEffect, useRef, useState } from 'react';
import TextTruncated from '../TextTruncated/TextTruncated';
import {
  getDetailPoster,
  generateGenres,
  generateCasts,
  formatDuration,
} from '../../utils';
import styles from './MediaInfo.module.css';
import './styles.css';

import shareIcn from '../../assets/ic-share-circle.svg';

import ShareModal from '../ShareModal/ShareModal';
import { showToastNotif } from '../../redux/actions/notification';
import { useDispatch } from 'react-redux';
import {
  addToMyList,
  getListStatus,
  removeFromMyList,
} from '../../redux/actions/myList';
import { useUserDetail } from '../../hooks';
import { authPopup } from '../../redux/actions/auth';
import { useSelector } from 'react-redux';
import AddToListButton from './AddToListButton';
import dablena from '../../service/dableIo';
import { useParams } from 'react-router-dom';

const WatchButton = ({ onWatchClicked, subscribed }) => {
  const btnRef = useRef();
  useEffect(() => {
    btnRef.current.focus();
  }, []);

  const watchByPress = (event) => {
    event.preventDefault();
    if (event.keyCode === 13) {
      onWatchClicked();
    }
  };
  return (
    <button
      onFocus={() => console.log('focus watch')}
      className={subscribed}
      onKeyDown={watchByPress}
      ref={btnRef}
      onClick={onWatchClicked}
      style={{
        whiteSpace: 'nowrap',
      }}
    >
      Watch Now
    </button>
  );
};

const MediaInfo = ({ detail, access, selectedSeason, onWatchClicked }) => {
  const poster = getDetailPoster(detail);
  const duration = detail.duration && formatDuration(detail.duration);
  const tags = detail.tags;
  const genres = generateGenres(tags);
  const dispatch = useDispatch();
  const casts = generateCasts(tags);
  const subscribed =
    !access || access.error ? styles['not-subscribed-button'] : '';
  const [showShareModal, setShowShareModal] = useState(false);
  const { partner } = useParams();
  const { findUserSubsByName } = useUserDetail();
  const hasPartnerSubs = findUserSubsByName(partner);
  const userToken = useSelector((state) => state.auth.token);

  useEffect(() => {
    if (userToken && detail.id) {
      dispatch(getListStatus(detail.id, detail.mediaType));
    }
  }, [detail.id, detail.mediaType, dispatch, userToken]); //check if it's in get list already

  const addToList = useCallback(() => {
    const doAddList = async () => {
      if (userToken) {
        try {
          await dispatch(addToMyList(detail.id, detail.type));

          //dable.io tracker
          dablena('AddToWishlist');

          return dispatch(showToastNotif('success', 'Added to My List.'));
        } catch (err) {
          return dispatch(showToastNotif('error', 'Error adding to My list.'));
        }
      } else {
        dispatch(authPopup.show());
      }
    };
    doAddList();
  }, [detail.id, detail.type, dispatch, userToken]);
  //fire 'add to list, if not logged in, show popup login/register

  const removeFromList = useCallback(() => {
    const doRemoveList = async () => {
      try {
        await dispatch(removeFromMyList(detail.id));
        return dispatch(showToastNotif('success', 'Removed from My List.'));
      } catch (err) {
        return dispatch(
          showToastNotif('error', 'Error removing from My list.')
        );
      }
    };
    doRemoveList();
  }, [detail.id, dispatch]);

  return (
    <div>
      <div key={detail.id} className='carousel-wrapper-container'>
        <img src={poster} alt='background-poster' />
        <div className='detail-wrapper'>
          <div className='detail'>
            <div className={styles['media-metadata-wrapper']}>
              <div className={styles['media-title']}>
                {detail.titleLocalized}{' '}
                {selectedSeason?.titleLocalized &&
                  `: ${selectedSeason?.titleLocalized}`}
              </div>
              <div className={styles['media-metadata']}>
                {!!detail.year && (
                  <span className={styles['year']}>{detail.year}</span>
                )}
                {!!genres && <span className={styles['genre']}>{genres}</span>}
                {!!duration && (
                  <span className={styles['duration']}>{duration}</span>
                )}
                {!!detail?.rating && (
                  <span className={styles['rating']}>{detail?.rating}</span>
                )}
              </div>
              <div className={styles['btn-wrapper']}>
                <WatchButton
                  subscribed={subscribed}
                  onWatchClicked={() => onWatchClicked()}
                />
                <div className={styles['wrapper-btn-circle']}>
                  {detail.id && (
                    <AddToListButton
                      addedToMyList={detail.addedToMyList}
                      onAddList={addToList}
                      onRemoveList={removeFromList}
                    />
                  )}
                  {!hasPartnerSubs && (
                    <>
                      <img
                        src={shareIcn}
                        alt='share'
                        onClick={() => setShowShareModal(!showShareModal)}
                      />
                    </>
                  )}
                </div>
              </div>
              <div className={styles['description']}>
                <TextTruncated
                  content={detail.descriptionLongLocalized || ''}
                  maxLength={250}
                />
              </div>
              {casts && (
                <div className={styles['casting']}>
                  <h3>Cast:</h3>
                  <span>{casts}</span>
                </div>
              )}
            </div>
          </div>
          <div className='item-thumbnail'>
            <img src={poster} alt='thumbnail' />
          </div>
        </div>
      </div>
      {showShareModal && (
        <ShareModal
          onCloseModal={() => setShowShareModal(!showShareModal)}
          type={detail.type}
          id={detail.id}
          showShareModal={showShareModal}
        />
      )}
    </div>
  );
};

export default MediaInfo;
